module.exports = "<div class=\"overlay\" *ngIf=\"show\">\n    <div id=\"spinner\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/spinner/spinner.component.html
// module id = ./src/app/core/components/spinner/spinner.component.html
// module chunks = main